module.exports = __webpack_public_path__ + "img/zhanglinlin.3c9c5da3.jpg";